module.exports = __webpack_public_path__ + "img/wintermute.fefec2d9.svg";